import { required } from "@/commons/utils/Rules";
import baseform2 from '../baseForm2';
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzDirection from "@/commons/forms/Fields/PzDirection";
export default {
  name: 'PzPersonForm3Oca',
  components: {
    PzFormFlujo: PzFormFlujo,
    PzDirection: PzDirection
  },
  mixins: [baseform2],
  data: function data() {
    return {
      formulario2: {
        direccion: {},
        info_extra: {
          direccion_entrega: {},
          tipo_entrega: '',
          tipo_sucursal: ''
        }
      },
      disable: true,
      rules_formulario2: {
        info_extra: {
          tipo_entrega: [required('')]
        },
        direccion: [required('')]
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created: function created() {
    this.activities2 = this.$t('forms_flujo.form2_persona.UY.info_montevideo');
    this.activities3 = this.$t('forms_flujo.form2_persona.UY.info_interior');
  },
  methods: {}
};